import React, { ReactNode } from 'react';
import { useTheme } from '@igo/ui';
import styles from './styles.module.scss';
import sun from './assets/sun.svg';
import moon from './assets/moon.svg';
import system from './assets/system.svg';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

interface ThemeButtonProps {
    onClick: () => void;
    themeItem: string;
    themeIcon: string;
}

interface ThemeToggleProps {
    className?: string;
    setTooltipContent: (p: ReactNode) => void;
}

const ThemeButton: React.FC<ThemeButtonProps> = ({ onClick, themeItem, themeIcon }) => {
    const { theme, isAutoTheme } = useTheme();
    const { t } = useTranslation();
    const activeTheme = isAutoTheme ? 'auto' : theme;
    return (
        <a
            className={cn(styles.tooltip__item, {
                [styles.tooltip__item__active]: themeItem === activeTheme,
            })}
            onClick={onClick}
        >
            {<img className={styles.tooltip__item__img} src={themeIcon} alt={t(themeItem)} />}
        </a>
    );
};

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className, setTooltipContent }) => {
    const { theme, isAutoTheme, toggleTheme } = useTheme();
    const { t } = useTranslation();
    const handleMouseEnter = () =>
        setTooltipContent(
            <div className={styles.tooltip}>
                <ThemeButton themeIcon={sun} themeItem={'light'} onClick={() => toggleTheme('light')} />
                <ThemeButton themeIcon={moon} themeItem={'dark'} onClick={() => toggleTheme('dark')} />
                <ThemeButton themeIcon={system} themeItem={'auto'} onClick={() => toggleTheme('auto')} />
            </div>
        );

    return (
        <div
            onMouseEnter={handleMouseEnter}
            data-tooltip-id="header-end-tooltip"
            className={`${styles.themeToggle} ${className || ''}`}
            aria-label={t(`switchTheme`)}
            title={t(`switchTheme`)}
        >
            <div className={styles.iconContainer}>
                {isAutoTheme ? (
                    // отображение текущей темы
                    <img src={system} alt={t('auto')} />
                ) : theme === 'light' ? (
                    <img src={sun} alt={t('light')} />
                ) : (
                    <img src={moon} alt={t('dark')} />
                )}
            </div>
        </div>
    );
};
